// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sHsv","colMin":"styles_colMin__1ibHl"};